var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lookbook-image",class:( _obj = { 'is-animated': _vm.isAnimated }, _obj[("is-" + _vm.direction)] = _vm.direction, _obj )},[_c('image-responsive',{attrs:{"mobile":_vm.source.mobile,"desktop":_vm.source.desktop,"desktop-x2":_vm.source.desktopX2,"alt":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }